import COSTS from "./allCosts";

const nameCostLine = (name, fontStyle, costString, width, height) => {
  // set up
  const canvas = document.createElement("canvas");
  canvas.height = height;
  canvas.width = width;
  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  if (name === "" || name === undefined) {
    return new Promise((res, rej) => {
      res(canvas.toDataURL("image/png"));
    });
  } else {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = fontStyle;
    ctx.fillText(name, 10, height - 10);

    if (costString === "" || costString === undefined) {
      return new Promise((res, rej) => {
        res(canvas.toDataURL("image/png"));
      });
    } else {
      const costs = costString.replace(/}{/g, "} {").split(" ");
			

      const costImgs = [];

      //reverse the list of mana costs and start drawing them R->L
      const initialOffset = width - height;

      costs.reverse().forEach((s, i) => {
        // images should be square and the size of the box
        const imgWidth = height - Math.round(height * 0.1);
        const imgHeight = height - Math.round(height * 0.1);
        const padding = 3;
        // image should start at top of box.

        const currentOffset = i * imgWidth + i * padding;
        const imgX = initialOffset - currentOffset;
        const imgY = 0;

        // draw a drop shadow
        const circle = new Path2D();
        // arc : x, y, radius
        circle.arc(
          imgX + Math.round(height / 2) - 6,
          Math.round(height / 2) + 3,
          Math.round(height / 2) - 4,
          0,
          2 * Math.PI
        );
        ctx.fill(circle);

        /// add cost to list of symbols to draw
        costImgs.push({
          src: COSTS[s],
          x: imgX,
          y: imgY,
          width: imgWidth,
          height: imgHeight,
        });
      });

      return Promise.all(
        costImgs.map((image) => {
          return new Promise((resolve, reject) => {
            const img = document.createElement("img");
            img.src = image.src;
            img.onload = () => resolve(img);
          });
        })
      ).then((imgs) => {
        imgs.forEach((img, idx) => {
          const loc = costImgs[idx];
          ctx.drawImage(img, loc.x, loc.y, loc.width, loc.height);
        });
        return canvas.toDataURL("image/png");
      });
    }
  }
};

export default nameCostLine;

/* 

Old "correct" to get the stuff from scryfall, but won't work because of CORS

return fetch("https://api.scryfall.com/symbology")
      .then((resp) => resp.json())
      .then((symbols) => {
        const required = symbols.data.filter(
          (s) => costs.indexOf(s.symbol) > -1
        );

        console.log(required);
       console.log(`mcm.ncl() : card name ${name}`);
       ctx.font = fontStyle;
       ctx.fillText(name, 10, height - 10);

       //reverse the list of mana costs and start drawing them R->L
       costs.reverse().forEach((s, i) => {
         const cImg = document.createElement("img");
         // images should be square and the size of the box
         const imgWidth = height;
         const imgHeight = height;
         // image should start at top of box.
         const imgX = 0;
         const imgY = width - imgWidth - i * imgWidth;
         // get the url out of required.
         cImg.src = required.reduce((acc, cur) => {
           if (cur.symbol == s) {
             return cur.svg_uri;
           }
           return acc;
         }, "");
         // draw the cost
         console.log(cImg);
         if (cImg.complete) {
           console.log(`img cost ${s} preloaded, drawing`);
           ctx.drawImage(cImg, imgX, imgY, imgWidth, imgHeight);
         } else {
           console.log(`img cost ${s} not loaded setting on load`);
           cImg.onload = () => {
             console.log(`img cost ${s} preloaded, drawing`);
             ctx.drawImage(cImg, imgX, imgY, imgWidth, imgHeight);
           };
         }
       });

       return canvas.toDataURL("image/png");
     })
     .catch((e) =>
       console.error(`Error getting symbols from scryfall ${e.stack}`)
     );
*/
